import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/constants/site";
import { Stars } from "@/components/Stars";

export const ReviewCard = ({ review }) => (
  <div
    data-testid="review-card"
    className="p-6 rounded-2xl bg-[#171324] border border-white/10 text-left"
  >
    <Stars rating={review.rating} />
    <p className="text-sm text-slate-300 leading-relaxed mt-3 mb-4">&ldquo;{review.text}&rdquo;</p>
    <div className="text-xs font-mono">
      <span className="text-white font-bold">{review.name}</span>
      <span className="text-slate-500 block mt-0.5">{review.service}</span>
    </div>
  </div>
);

const ReviewsSection = () => {
  const [data, setData] = useState({ reviews: [], count: 0, average: 0 });

  useEffect(() => {
    axios
      .get(`${API}/reviews`)
      .then((res) => setData(res.data))
      .catch(() => {});
  }, []);

  return (
    <section className="py-20 px-6 border-b border-white/5 bg-[#09070e]" data-testid="reviews-section">
      <div className="max-w-6xl mx-auto text-center">
        <div className="text-amber-400 text-sm mb-2">&#9733;&#9733;&#9733;&#9733;&#9733; 5-STAR QUALITY STANDARDS</div>
        <h2 className="font-poster text-3xl sm:text-4xl uppercase tracking-wide text-white mb-3">
          Client Feedback &amp; Rankings
        </h2>
        {data.count > 0 && (
          <div className="flex items-center justify-center gap-3 mb-10" data-testid="rating-summary">
            <span className="font-poster text-4xl text-white" data-testid="rating-average">{data.average}</span>
            <Stars rating={Math.round(data.average)} size={18} />
            <span className="text-xs font-mono text-slate-400" data-testid="rating-count">
              {data.count} verified reviews
            </span>
          </div>
        )}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {data.reviews.slice(0, 6).map((r) => (
            <ReviewCard key={r.id} review={r} />
          ))}
        </div>
        <a
          href="/reviews"
          data-testid="reviews-page-link"
          className="inline-block px-8 py-4 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 text-white font-bold text-xs font-mono uppercase tracking-wider transition-colors"
        >
          Read All Reviews &amp; Leave Yours &rarr;
        </a>
      </div>
    </section>
  );
};

export default ReviewsSection;
